<div class="contact-side-panel">
  <div class="inner-div">
    <span [innerHTML]="svg.contactSlideIcon | safeHtml" class="m-b-10" class="left-arrow-circle"></span>
    <!-- <img [src]="'/assets/images/contact/left-arrow-circle.png'"> -->
    <p [class]="languageCode">{{ 'Contact Us' | translate }}</p>
  </div>
  <ng-container *ngIf="contactList$.length > 0">
    <ng-container *ngFor="let item of contactList$; last as isLast">
      <div *ngIf="item.contact_type === 'Support'" class="contact-content" (click)="onContact(item.locales[0].link)" >
        <a [innerHTML]="svg[(item.image_icon.replace('.png', '') + 'Icon')] | safeHtml">
          <!-- <img [src]="'/assets/images/contact/' + item.image_icon" [alt]="item.name + ' Icon'"[ngClass]="{'border-0': isLast}"> -->
        </a>
      </div>
    </ng-container>
  </ng-container>
</div>